// extracted by mini-css-extract-plugin
module.exports = {"questions":"GetAllQuestions_questions__16vr9","score":"GetAllQuestions_score__2lRqt","congrats":"GetAllQuestions_congrats__3Pejk","home":"GetAllQuestions_home__3LaW2"};